<template>
  <div id="game-detail" ref="gameRoot"></div>
</template>
<script>
import { SDKGameView } from '@/components/GameRoom/gameRoom.js';
import { mapGetters } from 'vuex';
import GameRoomEventEmitter from '@/components/GameRoom/gameRoomEventBus';
import GameRoomEvent from '@/components/GameRoom/gameRoomEvent';
export default {
  name: 'GameDetail',
  props: {},
  data() {
    return {
      SudSDK: null,
      sudFSMMGCache: null,
      realWord: ''
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo.uuid ? Number(this.userInfo.uuid) : null;
    },
    roomId() {
      return this.$route.params.roomId;
    },
    gameId() {
      return this.$route.params.gameId;
    }
  },
  methods: {
    initGame() {
      try {
        let self = this;
        const root = this.$refs.gameRoot;
        if (root) {
          const nsdk = new SDKGameView({
            root,
            gameRoomId: this.roomId,
            gameId: this.gameId,
            userId: this.uuid
          });
          this.sudFSMMGCache = nsdk.sudFSMMGDecorator.sudFSMMGCache;

          nsdk.setSudFSMMGListener({
            onGameMGCommonKeyWordToHit(handle, model) {
              self.realWord = model.realWord;
            }
            // 监听玩家状态改变
            // onPlayerMGCommonPlayerIn(handle, userId, model) {
            //   // 获取游戏人数
            //   const size = nsdk.sudFSMMGDecorator.getPlayerInNumber();
            //   console.log(self.getSeatUsers());
            //   console.log(
            //     `=======sud h5 getPlayerInNumber======= size: ${size}, userId: ${userId}, model: ${JSON.stringify(
            //       model
            //     )}`
            //   );
            //   handle.success(JSON.stringify({ res_code: 0, msg: '' }));
            // }
            // onGameStarted () {
            //   console.log('========自定义的game start=====')
            // },
            // onGameMGCommonGameBackLobby (handle, data) {
            //   // 返回游戏大厅
            //   console.log('onGameMGCommonGameBackLobby', data)
            //   this.goBack && this.goBack(data)
            // }
          });
          // nsdk.setSudFSMMGListener({
          //   onGameStarted () {
          //     console.log('========自定义的game start=====')
          //   },
          //   onGameMGCommonGameBackLobby (handle, data) {
          //     // 返回游戏大厅
          //     console.log('onGameMGCommonGameBackLobby', data)

          //     this.goBack && this.goBack(data)
          //   }
          // })
          // 自定义loading
          // nsdk.beforeInitSdk = function (SudMGP) {
          //   return new Promise(() => {
          //     SudMGP.getSudCfg().setShowCustomLoading(true)
          //   })
          // }
          // nsdk.sudFSMMGDecorator.onGameLoadingProgress = function (stage: number, retCode: number, progress: number) {
          //   console.log(stage, retCode, progress, '自定义进度')
          // }
          this.SudSDK = nsdk;
          nsdk.login(this.uuid);
        }
      } catch (error) {
        this.$util.captureException(
          'game-room',
          { roomUid: this.roomId, fun: 'initGame' },
          error
        );
      }
    },
    getSeatUsers() {
      if (this.sudFSMMGCache && this.sudFSMMGCache.playerInSet) {
        let list = [];
        for (const [key, value] of this.sudFSMMGCache.playerInSet) {
          list.push(value);
        }
        return list;
      } else {
        return;
      }
    },
    // 檢查更新關鍵字是否正確，如果正確則輸出**
    wordKeyToHit(text) {
      if (this.realWord) {
        this.SudSDK.sudFSTAPPDecorator.notifyAPPCommonSelfTextHitState(
          text === this.realWord,
          this.realWord,
          text
        );
        if (text === this.realWord) {
          text = '**';
        }
      }
      return text;
    }
  },
  mounted() {
    this.$nextTick(async () => {
      if (!this.uuid) {
        await this.$store.dispatch('app/getUserInfo');
      }
      // this.initGame();
    });
    GameRoomEventEmitter.on(GameRoomEvent.onInitGame, () => {
      this.initGame();
    });
    GameRoomEventEmitter.on(GameRoomEvent.sendMessage, obj => {
      const { callback, message } = obj;
      callback(this.wordKeyToHit(message));
    });
  },
  destroyed() {
    this.SudSDK && this.SudSDK.onDestroy();
  }
};
</script>
<style lang="scss">
#game-detail {
  width: 100%;
  height: 100%;
  iframe {
    border: none;
  }
}
</style>
